import { RegistrationAttendeeMin } from './registration-attendee-min.model';
import { MenuItem } from 'primeng/api';

export class RegistrationMin {
  public constructor() {
    this.Id = 0;
    this.ProfileID = 0;
    this.DisplayName = '';
    this.OrgName = '';
    this.FirstName = '';
    this.LastName = '';
    this.Email = '';
    this.Phone = '';
    this.Paid = false;
    this.SignUpDate = new Date();
    this.AmountInvoiced = 0;
    this.AmountPaid = 0;
    this.ItemsDisplay = '';
    this.ShowDetails = false;
    this.Attendees = new Array<RegistrationAttendeeMin>();
    this.Member = false;
    this.OrgInd = false;
    this.Selected = false;
    this.InvoiceNum = 0;
  }
  public Id: number;
  public ProfileID: number;
  public ProfileReportName: string;
  public DisplayName: string;
  public OrgName: string;
  public FirstName: string;
  public LastName: string;
  public Email: string;
  public Phone: string;
  public Paid: boolean;
  public SignUpDate: Date;
  public AmountInvoiced: number;
  public AmountPaid: number;
  public ItemsDisplay: string;
  public ShowDetails: boolean;
  public LoadingDetails: boolean;
  public Attendees: Array<RegistrationAttendeeMin>;
  public Member: boolean;
  public OrgInd: boolean;
  public Selected: boolean = false;
  public InvoiceNum: number;
  public AttendeeCount: number = 0;
  public AttendeeHeadercount: number = 0;
  public PotentialAttendeeCount: number = 0;
  public BlankAttendeeCount: number = 0;
  public UnkownAttendeesCount: number = 0;
  public HasRefundableCCPayment: boolean = false;

  public _menuItems: MenuItem[];
}
